import { render } from "./IndexConfiguration.vue?vue&type=template&id=23b21606"
import script from "./IndexConfiguration.vue?vue&type=script&lang=js"
export * from "./IndexConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__